import React, { useRef, useState, useEffect } from 'react'
import ImagesList from './ImagesList'
import AddImage from './AddImage'
import './../styles/Main.css'

function Main({
	images,
	changeHandler,
	submitHandler,
	inputImageURL,
	removeHandler,
}) {
	const [sticky, setSticky] = useState(false)
	const [offset, setOffset] = useState(999)

	const [listEl, setListEl] = useState(null)
	const [addEl, setAddEl] = useState(null)

	const addImageEl = useRef(null)
	const imagesListEl = useRef(null)

	useEffect(() => {
		setListEl(imagesListEl.current)
		setAddEl(addImageEl.current)
	}, [addImageEl, imagesListEl])


	window.onscroll = () => {
		if (!addEl) return
		if (!addEl.children[0]) return
		scrollSticky()
	}

	const scrollSticky = () => {
		if (!sticky) {setOffset(addEl.children[0].offsetTop)}
		console.log(listEl.style.marginTop, offset);
		if (window.pageYOffset > offset) {
			setSticky(true)
			if (!addEl.children[0]) return
			listEl.style.marginTop = `${offset / 2}px`
		} else {
			setSticky(false)
			listEl.style.marginTop = '0px'
		}
	}

	return (
		<main>
			<div ref={addImageEl} style={{ height: 'auto' }}>
				<AddImage
					changeHandler={changeHandler}
					submitHandler={submitHandler}
					inputImageURL={inputImageURL}
					sticky={sticky}
				/>
			</div>
			<div ref={imagesListEl}>
				<ImagesList images={images} removeHandler={removeHandler} />
			</div>
		</main>
	)
}

export default Main
